// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1rdUj","notes":"Notes_notes__rNqLh","note":"Notes_note__1Ci5J","markdown":"Notes_markdown__31plo"};